import { Injectable } from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SharedService} from '../../../core/services/store/shared-store/shared-storage.service';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class BotService {

  constructor(private httpClient: HttpClient, private sharedService: SharedService) {
  }

  private httpOptions = {
    headers: new HttpHeaders({
      'accept': 'application/json',
      'X-API-VERSION': '1',
    }),
    withCredentials: true,
    observe: 'response' as 'body'
};

  private botBaseURI(): string {
    return `${environment.controlBaseUrl}${environment.flowManagerBaseUri}/${this.sharedService.getEnvironment()}/${this.sharedService.getEntityType()}/${this.sharedService.getEntityId()}`;
  }
  private templateBaseURI(): string {
    return `${environment.controlBaseUrl}${environment.flowManagerBaseUriV2}/${this.sharedService.getEnvironment()}/${this.sharedService.getEntityType()}/${this.sharedService.getEntityId()}`;
  }


  getBot(botId: string): Observable<any> {
    return this.httpClient
        .get(
            this.botBaseURI() + '/bots/' + botId,
            this.httpOptions);
  }

  getBotList(): Observable<any> {
    return this.httpClient
        .get(
        this.botBaseURI() + '/bots',
            this.httpOptions);
  }

  saveNewBot(botMetadata: any): Observable<any> {
    return this.httpClient
        .post(
            this.botBaseURI() + '/bots',
            botMetadata,
            this.httpOptions
        );
  }

  updateExistingBot(botId: string, botMetadata: any): Observable<any> {
    return this.httpClient
        .patch(
            this.botBaseURI() + '/bots/' + botId,
            botMetadata,
            this.httpOptions
        );
  }

  saveTemplate(botMetadata: any): Observable<any> {
    return this.httpClient
        .post(
            this.templateBaseURI() + '/flows/create',
            botMetadata,
            this.httpOptions
        );
  }

}
